export default {
  mapView: {
    'routeTo': 'Calcular la ruta a este lugar',
    'polygonDetails': 'Detalles del polígono',
    'polygon': 'Polígono',
    'whatIsHere': '¿Qué hay aquí?',
    'directionsFromHere': 'Ruta desde aquí',
    'fitAllFeatures': 'Mostrar todos los elementos',
    'addRouteStop': 'Añadir parada aquí',
    'addDestinationToRoute': 'Añadir a la ruta',
    'acquirePositionErrors': {
      'generic': 'Su ubicación no pudo ser adquirida porque no fue autorizada o porque el navegador/dispositivo no lo soporta.',
      'unavailable': 'Según su dispositivo, su ubicación no está disponible actualmente. Asegúrese de que la opción/servicio de posicionamiento está correctamente configurado.',
      'permissionDenied': 'Su posición no ha podido ser adquirida porque el dispositivo le ha negado el acceso. Puedes volver a intentarlo cambiando la configuración del dispositivo y haciendo clic de nuevo en el botón \'mi posición\'.',
      'timeout': 'Su dispositivo ha devuelto el \'tiempo de espera\' al intentar comprar una posición. Puede volver a intentarlo haciendo clic en el botón \'mi posición\'.'
    },
    'yourCurrentLocation': 'Su ubicación actual',
    'options': 'Opciones',
    'polylineMeasure': {
      'bearingTextIn': 'Dentro',
      'bearingTextOut': 'Fuera',// HERE
      'tooltipTextDragAndDelete': 'Haga clic y arrastre para <b>mover un punto</b>br>Pulse la tecla SHIFT y haga clic para <b>borrar un punto</b>.',
      'tooltipTextResume': '<br>Pulsa la tecla CTRL y haz clic para <b>continuar una línea</b>',
      'tooltipTextDelete': 'Pressione  SHIFT e clique para <b>excluir um ponto</b>',
      'tooltipTextAdd': 'Pulse la tecla CTRL y haga clic para <b>añadir un punto</b>.',
      'clearControlTitle': 'Limpiar las medidas',
      'measureControlTitleOn': 'Activar la medición de la distancia',
      'measureControlTitleOff': 'Desactivar la medición de la distancia',
      'unitControlTitle': {
        'text': 'Cambio de unidades',
        'metres': 'metros',
        'landmiles': 'millas terrestres',
        'nauticalmiles': 'millas náuticas'
      },
      'clearControlLabel': '&times',
      'measureControlLabel': '&#8614;',
      'measureControlClasses': [],
      'unitControlLabel': {
        'metres': 'm',
        'kilometres': 'km',
        'feet': 'pies',
        'landmiles': 'M',
        'nauticalmiles': 'MN'
      }
    },
    'defineAvoidPolygon': 'Definir los polígonos a evitar en la ruta',
    'defineAvoidRectangle': 'Establecer los rectángulos a evitar en la ruta',
    'youCantIntersectPolygons': 'No se pueden intersecar polígonos',
    'polygonArea': 'Área del polígono',
    'highlighting': 'Resalte',
    'accuracy': 'Precisión',
    'youCanCenterAtYourLocationLater': 'Puedes centrar el mapa en su ubicación actual en cualquier momento haciendo clic en el botón \'mi ubicación\'.',
    'yourLocation': 'Utiliza su ubicación',
    'setMyLocationAsMapCenter': '¿Quieres centrar el mapa en su ubicación actual? Esto mejorará la precisión de la búsqueda de lugares. Tendrá que autorizarlo, si se le solicita.',
    'removePlace': 'Eliminar lugar',
    'viewOnORS': 'Ver en ORS',
    'moveMapPositionToLeft': 'Mover el mapa a la izquierda',
    'moveMapPositionToRight': 'Mover el mapa a la derecha',
    'moveMapPositionToUp': 'Mover el mapa hacia arriba',
    'moveMapPositionToDown': 'Mover el mapa hacia abajo',
    'toggleDirect': 'Pase directamente de aquí a la siguiente ubicación',
    'heightGraph': {
      'distance': 'Distancia',
      'elevation': 'Elevación',
      'segment_length': 'Distancia del segmento',
      'type': 'Tipo',
      'legend': 'Leyenda'
    },
    'editShape': 'Cambiar la forma',
    'remove': 'Eliminar',
    'avoidPolygonSaved': 'Polígono que debe evitarse guardado',
    'avoidPolygonRemoved': 'Polígono a evitar excluido',
    'avoidPolygonNotRemoved': 'No se puede excluir el polígono a evitar',
    'avoidPolygonNotSaved': 'No se puede guardar el polígono para evitar',
    'polygonEditModeEnabled': 'Cuando haya terminado de hacer los cambios, haga clic en cualquier lugar para guardar',
    'customTileProvider': 'Proveedor de mapas definido por el usuario',
    'gestureHandling': {
      'touch': 'Usa dos dedos para mover el mapa',
      'scroll': 'Pulse Ctrl y desplace la pantalla simultáneamente para ampliar el mapa',
      'scrollMac': 'Utilice ⌘ y desplace la pantalla simultáneamente para ampliar el mapa'
    }
  }
}
